module.exports = __webpack_public_path__ + "img/bsAttrCard_icon_02.3a0dc56f.png";